var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel d-flex align-items-md-center"},[_c('b-form-checkbox',{attrs:{"size":"sm","value":_vm.checked,"unchecked-value":_vm.unchecked},on:{"change":_vm.onDataChange},model:{value:(_vm.IsValue),callback:function ($$v) {_vm.IsValue=$$v},expression:"IsValue"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }